module.exports = __webpack_public_path__ + "static/media/emse.b1ca167d.jpg";